import { render } from "./modou.vue?vue&type=template&id=4be36c37&scoped=true"
import script from "./modou.vue?vue&type=script&lang=js"
export * from "./modou.vue?vue&type=script&lang=js"

import "./modou.vue?vue&type=style&index=0&id=4be36c37&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4be36c37"

export default script